import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBudget = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 20,
	viewBox: "0 0 14 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "elements",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.3466 6.79077C12.3466 4.88164 9.95254 3.33398 6.99935 3.33398C4.04616 3.33398 1.65213 4.88164 1.65213 6.79077C1.65213 8.69991 3.11046 9.75374 6.99935 9.75374C10.8882 9.75374 12.8327 10.7414 12.8327 13.2105C12.8327 15.6797 10.221 16.6673 6.99935 16.6673C3.77769 16.6673 1.16602 15.1197 1.16602 13.2105",
			stroke: "#141B34",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector 4578",
			d: "M7 1.66699V18.3337",
			stroke: "#141B34",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgBudget;
